import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/caller';

/**
 * Find tour location by slug
 * @param tourSlug string
 * @returns UseQueryResult<SearchViewModel[]>
 */
export const useFindTourLocationBySlug = (tourSlug = '', enabled = true) => {
  const isLongEnough: boolean = tourSlug?.length >= 3;

  return useQuery({
    queryKey: ['tour-location-search', tourSlug],
    queryFn: async () => {
      return await callService('SearchesService', 'searchesUrl', {
        s: tourSlug,
        webUrl: 'Tour',
      });
    },
    enabled: isLongEnough && enabled,
  });
};
